import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <section className="flex min-h-[calc(100vh-200px)] flex-1 items-center justify-center px-6 py-20">
      <div className="max-w-[480px] text-center">
        <div className="font-mono-data mb-4 text-[0.72rem] font-bold tracking-widest text-brand uppercase">404</div>
        <h1 className="font-display mb-4 text-[2.5rem] leading-[1.08] font-extrabold text-ink lg:text-[3rem]">
          Page not found.
        </h1>
        <p className="mb-8 text-[1rem] leading-[1.7] text-ink-3">
          This page doesn&apos;t exist. It may have moved, or the link may be wrong.
        </p>
        <div className="flex flex-col justify-center gap-3 sm:flex-row">
          <Link
            to="/"
            className="inline-flex items-center justify-center rounded-xl bg-brand px-7 py-3.5 font-semibold text-brand-on hover:bg-brand-hover"
          >
            Go home
          </Link>
          <Link
            to="/help"
            className="inline-flex items-center justify-center rounded-xl border border-line-strong px-7 py-3.5 font-semibold text-ink hover:bg-surface-2"
          >
            Search help
          </Link>
        </div>
      </div>
    </section>
  );
}
